import React from "react";
import { Badge } from "primereact/badge";

export type HourType = "billable" | "non_billable" | "non_working";

interface ActivityBadgeProps {
  value: string;
  hourType: HourType;
  className?: string;
  size?: "normal" | "large" | "xlarge";
}

export const ActivityBadge: React.FC<ActivityBadgeProps> = ({
  hourType,
  value,
  className = "",
  size = "normal",
}) => {
  // Define colors and styles for each hour type
  const getBadgeStyle = (type: HourType) => {
    switch (type) {
      case "non_working":
        return {
          backgroundColor: "#22c55e", // green-500
          color: "white",
        };
      case "non_billable":
        return {
          backgroundColor: "#3b82f6", // blue-500
          color: "white",
        };
      case "billable":
        return {
          backgroundColor: "#a855f7", // purple-500
          color: "white",
        };
      default:
        return {
          backgroundColor: "#6b7280", // gray-500
          color: "white",
        };
    }
  };

  const style = getBadgeStyle(hourType);

  return (
    <Badge
      value={value}
      severity="info"
      size={size}
      className={className}
      style={{
        ...style,
      }}
    />
  );
};

interface ReferenceBadgeProps {
  value: string;
  className?: string;
  size?: "normal" | "large" | "xlarge";
}

export const ReferenceBadge: React.FC<ReferenceBadgeProps> = ({
  value,
  className = "",
  size = "normal",
}) => {
  const style = {
    backgroundColor: "var(--surface-200)",
    color: "var(--text-color-secondary)",
  };

  return (
    <Badge
      value={value}
      severity="info"
      size={size}
      className={className}
      style={{
        ...style,
      }}
    />
  );
};

export default ActivityBadge;
